export const namespace = 'planet';

export const me = () => [namespace, 'me'] as const;
export const detail = (uid: string | number) => [namespace, 'detail', String(uid)] as const;
export const energies = (uid: string | number, page = 1) => [namespace, 'energies', String(uid), page] as const;
export const rankings = (type: 'energy' | 'steal', period: 'day' | 'week' | 'all') => [namespace, 'rankings', type, period] as const;
export const dividends = (period: 'day' | 'week' | 'month') => [namespace, 'dividends', period] as const;
export const mintedPlanets = (page = 1) => [namespace, 'mintedPlanets', page] as const;
export const mintPreview = (lng: number, lat: number) => [namespace, 'mintPreview', +lng.toFixed(6), +lat.toFixed(6)] as const;

